import { render, staticRenderFns } from "./inviteUser.vue?vue&type=template&id=728b03e6&scoped=true&"
import script from "./inviteUser.vue?vue&type=script&lang=js&"
export * from "./inviteUser.vue?vue&type=script&lang=js&"
import style0 from "./inviteUser.vue?vue&type=style&index=0&id=728b03e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728b03e6",
  null
  
)

export default component.exports